export const apiUrl = 'https://frapp33.herokuapp.com'
export const DEFAULT_MESSAGE_TIMEOUT = 3000
